import { useContext, useState } from 'react'
import { Configuration, ConfiguratorContext } from '../../Contexts/Configuration'
import ImageLayout from '../../Layouts/ImageLayout/ImageLayout'
import { NavigationNode } from '../../Services/Navigation'
import ViewType from '../../Types/ViewType'
import Radio from '../../../../Components/Radio/Radio'
import './PortabilityNumberView.css'
import { validatePhoneNumber } from '../../Services/Validation'

const PortabilityNumberView = () => {
    let context = useContext(ConfiguratorContext)

    let [keepNumber, setKeepNumber] = useState(context.keepNumber ?? true)
    let [number1, setNumber1] = useState(context.currentPhoneNumber1 ?? '')
    let [number2, setNumber2] = useState(context.currentPhoneNumber2 ?? '')
    let [number3, setNumber3] = useState(context.currentPhoneNumber3 ?? '')
    let [number4, setNumber4] = useState(context.currentPhoneNumber4 ?? '')
    let [inboundCallNumber, setInboundCallNumber] = useState(context.inboundCallNumber ?? '')

    let [errors, setErrors] = useState<string[]>([])

    context.validatePortabilityNumber = () => {
        let validNumber1 = validatePhoneNumber(number1.replaceAll(" ", ""))
        let validNumber2 = number2 !== '' ? validatePhoneNumber(number2.replaceAll(" ", "")) : true
        let validNumber3 = number3 !== '' ? validatePhoneNumber(number3.replaceAll(" ", "")) : true
        let validNumber4 = number4 !== '' ? validatePhoneNumber(number4.replaceAll(" ", "")) : true
        let validInboundCallNumber = validatePhoneNumber(inboundCallNumber.replaceAll(" ", ""))

        if (keepNumber) {
            let errors = []


            if (!validNumber1) {
                errors.push("- Numero 1 non valido\n")
            }
            if (!validNumber2) {
                errors.push("- Numero 2 non valido\n")
            }
            if (!validNumber3) {
                errors.push("- Numero 3 non valido\n")
            }
            if (!validNumber4) {
                errors.push("- Numero 4 non valido\n")
            }

            if (!validInboundCallNumber) {
                errors.push("- Numero di inoltro chiamate entranti non valido\n")
            }

            if (errors.length !== 0) {
                setErrors(errors)
            }

            let res = validNumber1 && validNumber2 && validNumber3 && validNumber4 && validInboundCallNumber

            if (res) {
                context.currentPhoneNumber1 = number1
                context.currentPhoneNumber2 = number2
                context.currentPhoneNumber3 = number3
                context.currentPhoneNumber4 = number4
                context.inboundCallNumber = inboundCallNumber
                context.keepNumber = keepNumber
            }

            return res

        } else {
            let errors = []

            if (!validInboundCallNumber) {
                errors.push("- Numero di inoltro chiamate entranti non valido\n")
                setErrors(errors)
            }

            if (validInboundCallNumber) {
                context.inboundCallNumber = inboundCallNumber
            }

            return validInboundCallNumber
        }
    }

    function NumberInput() {
        if (keepNumber) {
            return (
                <div>
                    <div>
                        <div className="portability-number-title">Inserisci uno o più numeri per cui richiedi
                            la portabilità</div>
                        <div className="portability-number-subtitle">Inserisci il numero nel formato +39XXXXXXXXXX</div>
                        <input value={number1} onChange={n => setNumber1(n.target.value)} className="portability-number-input" />
                        <input value={number2} onChange={n => setNumber2(n.target.value)} className="portability-number-input" />
                        <input value={number3} onChange={n => setNumber3(n.target.value)} className="portability-number-input" />
                        <input value={number4} onChange={n => setNumber4(n.target.value)} className="portability-number-input" />
                    </div>
                </div>
            )
        }
    }

    return (
        <ImageLayout src="../assets/phone.png">
            <div className="portability-number-container">
                <div>
                    <div className="portability-number-label-question">Desideri mantenere il tuo numero attuale?</div>
                    <div className="portability-number-question">
                        <Radio title='Si' onChange={() => setKeepNumber(true)} checked={keepNumber} />
                        <Radio title='No' onChange={() => setKeepNumber(false)} checked={!keepNumber} />
                    </div>
                </div>

                {NumberInput()}

                <div>
                    <div className="portability-number-title">Inserisci il numero per l'inoltro delle chiamate entranti</div>
                    <div className="portability-number-subtitle">Inserisci il numero nel formato +39XXXXXXXXXX</div>
                    <input value={inboundCallNumber} onChange={n => setInboundCallNumber(n.target.value)} className="portability-number-input" />
                </div>

                <div className='portability-number-errors-container'>
                    <div className='portability-number-errors'>
                        {errors.map((x, i) => <div className='portability-number-error' key={i}>{x}</div>)}
                    </div>
                </div>

            </div>
        </ImageLayout>
    )
}

const PortabilityNumberNode: NavigationNode = {
    content: () => <PortabilityNumberView />,
    percentage: 75,
    previous: (_: Configuration) => ViewType.optionsView,
    next: (_: Configuration) => ViewType.paymentMode
}

export default PortabilityNumberNode